import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import BidCard from './BidCard';
import Illustration from '../../Illustration';
import { selectBidList } from '../../../store/selectors';

const styles = theme => ({
  root: {
  },

});

const BidsCards = ({ classes, bids, startEditAdmin }) => {
  return(
    <div className={classes.root}>
      {bids.length > 0 &&
        bids.map((bid, i) => {
          return <BidCard key={i} bid={bid} />
        })
      }
      {bids.length === 0 &&
        <Illustration
          title="Hmm, no Bids..."
          imgKey="business_deal"
          explainerText="Either you've not entered any or your filter had no results."
          addItemText="Enter a new Bid by clicking the 'Floating Action Button' at top right."
        />
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bids: selectBidList(state),
  };
};


export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(BidsCards);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/BidsCards.jsx